import React from "react";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import useScreenOptionsHooks from "../../../../../hooks/useScreenOptionsHooks";
import LineViewContainer from "@scenes/requests/utils/LineView";
import { formatNumberWithPrecision } from "@utils/product/productFormatters";

export type OrderSummaryLine = {
  label: string;
  value: number;
  bold?: boolean;
};

export type OrderSummaryProps = {
  lines: OrderSummaryLine[];
  estimatedTotal: number;
};

const OrderSummary: React.FC<OrderSummaryProps> = ({
  lines,
  estimatedTotal,
}) => {
  const { theme, typography, t } = useScreenOptionsHooks();

  return (
    <Container>
      <SummaryCard>
        {lines.map((line, idx) => (
          <>
            <Row key={`${line.label}-${idx}`}>
              <VDBText
                type={line.bold ? typography["Body-M"] : typography["Body-R"]}
                color={line.bold ? theme["core-05"] : theme["core-06"]}
              >
                {line.label}
              </VDBText>
              <VDBText
                type={line.bold ? typography["Body-M"] : typography["Body-R"]}
                color={line.bold ? theme["core-05"] : theme["core-06"]}
              >
                {line.value < 0 ? "-$" : "$"}
                {formatNumberWithPrecision(Math.abs(line.value), {
                  precision: 2,
                })}
              </VDBText>
            </Row>
            {idx !== lines.length - 1 && <Spacer size={SpaceType.ExtraSmall} />}
          </>
        ))}
        <Spacer size={SpaceType.Extra} />
        <LineViewContainer background={"core-03"} />
        <Spacer size={SpaceType.Extra} />
        <TotalRow>
          <VDBText type={typography["Body-R"]} color={theme["core-06"]}>
            {t("managePlan.popUp.estimatedTotal.text", "Estimated Total")}
          </VDBText>
          <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
            ${formatNumberWithPrecision(estimatedTotal, { precision: 2 })}
          </VDBText>
        </TotalRow>
      </SummaryCard>
    </Container>
  );
};

const Container = styled.View`
  width: 100%;
`;

const SummaryCard = styled.View`
  background-color: ${({ theme }) => theme["core-02"]};
  border-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Double}px;
`;

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TotalRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export default OrderSummary;
